const roundNumber = (num: number | undefined, precision = 1) => {
  if (num === undefined) return 0;

  return Number.parseFloat(num.toFixed(precision));
};

export default roundNumber;
